module.exports = __webpack_public_path__ + "static/media/icone-viewer-branco.9c8301c2.svg";